module.exports = __webpack_public_path__ + "assets/imgs/logos/yahooJapan.4942a6e7ded2a8c5e688b0b62a41de1a.png";